require('./jquery-ui-custom.min');
require('jquery-ui-touch-punch');
require('tether');
require('./slider.js');
require('./mtiFontTrackingCode.js');
require('./header.js');
require('lazysizes');
require("lazysizes/plugins/rias/ls.rias");
var objectFitImages = require('object-fit-images');

AOS.init();

// grab an element
var myElement = document.querySelector("header");
// construct an instance of Headroom, passing the element
var headroom  = new Headroom(myElement);
// initialise
headroom.init();

$(function () { objectFitImages(); });

// FOOTER NEWSLETTER FORM
function FooterNewsletterFormHandler() {
  // these values map to the NewsletterSubscriptionResult enum - don't change these values.
  this.responseCodes = {
    success: 0,
    failureInvalid: 1,
    failureGeneric: 2
  };
  this.form = $("#footer-newsletter-subscription-form");
  this.emailInput = $("#footer-newsletter-subscription-form-email");
  this.containerSuccess = $("#footer-newsletter-subscription-form-success");
  this.containerFailureGeneric = $("#footer-newsletter-subscription-form-failure-generic");
  this.containerFailureInvalid = $("#footer-newsletter-subscription-form-failure-invalid");
  this.spinner = $("#footer-newsletter-subscription-form-spinner");
}

FooterNewsletterFormHandler.prototype.showErrorInvalid = function () {
  // put the form into error state and show invalid error message
  if (!this.form.hasClass("form-error"))
    this.form.addClass("form-error");
  this.containerFailureGeneric.hide();
  this.containerFailureInvalid.show();
};

FooterNewsletterFormHandler.prototype.showErrorGeneric = function () {
  // put the form into error state and show generic error message
  if (!this.form.hasClass("form-error"))
    this.form.addClass("form-error");
  this.containerFailureInvalid.hide();
  this.containerFailureGeneric.show();
};

FooterNewsletterFormHandler.prototype.showSuccess = function () {
  // hide the form entirely and show success message
  this.form.hide();
  this.containerSuccess.show();
};

FooterNewsletterFormHandler.prototype.init = function () {

  // required so we can access from within a function
  var self = this;

  // handle submit event of form
  this.form.submit(function (event) {

    // prevent form doing full postback
    event.preventDefault();

    // anything goes wrong, display error
    try {
      
      var email = self.emailInput.val();

      // nicked from https://stackoverflow.com/a/742588, same regex used clientside and serverside
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        self.showErrorInvalid();
        return;
      }

      var requestData = self.form.serialize();

      self.spinner.show();

      $.ajax({
        type: "POST",
        url: self.form.attr("action"),
        data: requestData
      }).done(function (response) {
        if (response === self.responseCodes.success) {
          self.showSuccess();
        } else if (response === self.responseCodes.failureInvalid) {
          self.showErrorInvalid();
        } else {
          self.showErrorGeneric();
        }
      }).fail(function (data) {
        console.log(data);
        throw "Communication failure.";
      }).always(function() {
        self.spinner.hide();
      });

    } catch (err) {

      // show error and display in console
      self.showErrorGeneric();
      console.log(err);

    }

  });
};

var footerNewsletterFormHandler = new FooterNewsletterFormHandler();
footerNewsletterFormHandler.init();


// WEBPACK FOOTER //
// ./js/app.js